import React from 'react';
import { Alert, Snackbar, Box, Typography, IconButton } from '@mui/material';
import { Close as CloseIcon, WifiOff as WifiOffIcon } from '@mui/icons-material';

interface ConnectionErrorPopupProps {
  isVisible: boolean;
  onClose: () => void;
}

const ConnectionErrorPopup: React.FC<ConnectionErrorPopupProps> = ({ isVisible, onClose }) => {
  return (
    <Snackbar
      open={isVisible}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{
        '& .MuiSnackbarContent-root': {
          minWidth: '350px',
        },
      }}
    >
      <Alert
        severity="error"
        sx={{
          width: '100%',
          backgroundColor: '#d32f2f',
          color: 'white',
          '& .MuiAlert-icon': {
            color: 'white',
          },
        }}
        icon={<WifiOffIcon />}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        <Box>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
            Connection Error
          </Typography>
          <Typography variant="body2">
            The server side of this application is down or unreachable. Please check your connection or try again later.
          </Typography>
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default ConnectionErrorPopup;